import { render, staticRenderFns } from "./RelatorioSinteticoAnaliticoFormacoesFuncao.vue?vue&type=template&id=98c2fce6&scoped=true"
import script from "./RelatorioSinteticoAnaliticoFormacoesFuncao.vue?vue&type=script&lang=js"
export * from "./RelatorioSinteticoAnaliticoFormacoesFuncao.vue?vue&type=script&lang=js"
import style0 from "./RelatorioSinteticoAnaliticoFormacoesFuncao.vue?vue&type=style&index=0&id=98c2fce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c2fce6",
  null
  
)

export default component.exports